module.exports = __webpack_public_path__ + "img/network.e4671de2.svg";